<template>
  <v-menu offset-x right :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on"><v-list-item-title>Edit</v-list-item-title></v-list-item>
    </template>
    <v-card flat width="350">
      <v-card-title>Batch edit</v-card-title>
      <v-card-subtitle>Only checked fields will be updated</v-card-subtitle>
      <v-card-text class="pa-0">
        <v-container class="pt-0 px-6">
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="input.updateActive"/>
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Active" v-model="input.active" hide-detlails :disabled="!input.updateActive"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-simple-checkbox v-model="input.updateCategory" class="mt-2"/>
            </v-col>
            <v-col>
              <inventory-categories-select v-model="input.categoryId" label="Category" type="Customer" allow-add hide-detalils :disabled="!input.updateCategory"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-simple-checkbox v-model="input.updateType" class="mt-2"/>
            </v-col>
            <v-col>
              <v-autocomplete v-model="input.type" outlined dense label="Type" :items="types" :disabled="!input.updateType"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-simple-checkbox v-model="input.updateTerm" class="mt-2"/>
            </v-col>
            <v-col>
              <v-autocomplete v-model="input.termId" outlined dense label="Terms"
                              :disabled="!input.updateTerm"
                              :items="terms" item-text="name" item-value="id"/>
            </v-col>
          </v-row>
          <v-row v-if="salesReps.length > 1">
            <v-col cols="2">
              <v-simple-checkbox v-model="input.updateSalesRep" class="mt-2"/>
            </v-col>
            <v-col>
              <v-autocomplete v-model="input.salesRepId" outlined dense label="Sales representative"
                              :disabled="!input.updateSalesRep"
                              :items="salesReps" item-text="name" item-value="id"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-simple-checkbox v-model="input.updateShipmentZone" class="mt-2"/>
            </v-col>
            <v-col>
              <shipment-zones-select v-model="input.shipmentZoneId" label="Shipment zone" allow-add :disabled="!input.updateShipmentZone"/>
            </v-col>
          </v-row>
        </v-container>
        <v-divider/>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="open=false">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import InventoryCategoriesSelect from '@/views/inventory/categories/InventoryCategoriesSelect'
import ShipmentZonesSelect from '@/views/sales/shipmentZones/SalesShipmentZonesSelect'
import customerTypes from '@/mixins/customerTypes'

export default {
  name: 'SalesCustomersBatchEdit',
  mixins: [customerTypes],
  components: {InventoryCategoriesSelect,ShipmentZonesSelect},
  props: {
    customers: {type:Array, required:true}
  },
  data() {
    return {
      open: false,
      input: {updateActive: false, updateCategory: false, updateType: false, updateTerm: false, updateSalesRep: false, updateShipmentZone:false,
              active:true, categoryId: null, type: 'None', termId:'', salesRepId:'', shipmentZoneId:'',
              customers:[]},
      types: [],
      terms: [{id:'',name:''}],
      salesReps: [{id:'',name:''}],
      saving: false
    }
  },
  async created() {
    this.$lazyListLoad(this.salesReps, 'salesReps2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}])
    this.$lazyListLoad(this.terms, 'terms2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}])
    this.types = await this.buildCustomerTypes();
  },
  methods: {
    async save() {
      this.saving = true;
      this.input.customers = this.customers.map(customer => customer.id);
      const results = await this.$apiCall(`mutation SalesCustomersBatchEdit($input: CustomerBatchUpdateInput!) {
                                              customersBatchUpdate(input:$input) {id,error}
                                            }`,
                                          {input:this.input});
      this.saving = false;
      if (!results.error) {
        this.open = false;
        const errorCount = results.data.customersBatchUpdate.length;
        this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                        message:`Updated ${this.customers.length - errorCount} of ${this.customers.length} customers\
                                                  ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
        this.$emit('refresh', results.data.customersBatchUpdate);
        this.$store.commit("customersReset");
      }
    }
  }
}
</script>